module.exports = __webpack_public_path__ + "fonts/silk_serif_light-webfont.1c3229d.ttf";